<template>
  <el-dialog
    title="标签信息"
    :visible.sync="visible"
    width="840px"
    append-to-body
    @closed="handleClosed">
    <el-form
      ref="form"
      v-loading="loading"
      label-width="90px">
      <el-form-item label="商品名称：">{{ info.skuName }} </el-form-item>
      <el-form-item label="商品编码：">{{ info.skuCode }} </el-form-item>
      <el-form-item
        label=""
        label-width="0">
        <el-divider>共{{ list.length }}条标签信息</el-divider>
        <el-table
          border=""
          max-height="500px"
          :data="list">
          <el-table-column
            label="批次号"
            :resizable="false"
            min-width="120"
            prop="batchCode">
            <template slot-scope="{row}">
              <link-route
                :link-to="`/batch-detail?vendorId=${userInfo.vendorId}&batchId=${row.batchId}&productId=${row.productId}`">
                {{ row.batchCode }}
              </link-route>
            </template>
          </el-table-column>
          <el-table-column
            label="箱码序号"
            :resizable="false"
            min-width="120"
            prop="formatedSetNo">
          </el-table-column>
          <el-table-column
            prop="formatedTagNo"
            label="产品码序号"
            min-width="120">
          </el-table-column>
          <el-table-column
            label="发货时间"
            :resizable="false"
            width="145">
            <template slot-scope="{row}">
              {{ row.outstockTime | dateformat() }}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button
        style="margin-left: 10px"
        :loading="loading"
        @click="visible=false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'OutStockTagButton',
  data() {
    return {
      loading: false,
      visible: false,
      config: {},
      info: {},
      list: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  methods: {
    handleClosed() {},
    fetchList() {
      this.loading = true
      this.$store.dispatch('outstock/getoutstocktags', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          const records = res.data.records
          const list = []
          records.forEach(i => {
            if (i.isSetcode === 1) {
              const listNew = (i.tagNos || []).map(m => {
                return {
                  formatedSetNo: i.formatedTagNo,
                  ...i,
                  formatedTagNo: m
                }
              })
              list.push(...listNew)
            } else {
              list.push({
                formatedSetNo: '-',
                ...i
              })
            }
          })
          this.list = list
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(config, info) {
      this.config = {
        ...this.config,
        ...config
      }
      this.info = info
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
